class TestimonialSlider extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-slider-viewport]');
    this.track = this.querySelector('[data-slider-track]');
    this.previous = this.querySelector('[data-slider-prev]');
    this.next = this.querySelector('[data-slider-next]');
    if (!this.viewport || !this.track || !this.previous || !this.next) return;

    this.previous.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.viewport.addEventListener('scroll', () => this.updateControls(), { passive: true });
    window.addEventListener('resize', () => this.updateControls());
    this.updateControls();
  }

  move(direction) {
    const card = this.track.querySelector('.testimonial-split__card');
    const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
    const amount = (card?.getBoundingClientRect().width || this.viewport.clientWidth) + gap;
    this.viewport.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  updateControls() {
    const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
    const position = this.viewport.scrollLeft;
    this.previous.disabled = position <= 1;
    this.next.disabled = position >= maximum - 1;
  }
}

if (!customElements.get('testimonial-slider')) customElements.define('testimonial-slider', TestimonialSlider);
